export default [
    {
        path: '/autologin',
        name: 'autologin',
        // Use HomePage component (same as /login) to handle JWT auto-login
        // This allows /autologin?jwt=xxx to work exactly like /login?jwt=xxx
        component: () => import(/* webpackChunkName: "homepage" */ '@/views/HomePage.vue')
    },
    {
        path: '/sso',
        name: 'sso',
        redirect: to => {
            // Preserve all query params when redirecting to login
            return { path: '/login', query: to.query }
        }
    },
]

